import { TabbedPage, TabbedPageEnum } from '@/features/TabbedPage';
import type { AdManagementNextPage } from '@/types';
import { ZRAMPageLayout } from '@/app/layout/ZRAMPageLayout';

const SalesProPage: AdManagementNextPage = () => <TabbedPage tab={TabbedPageEnum.SalesPro} />;

SalesProPage.getLayout = (page) => <ZRAMPageLayout>{page}</ZRAMPageLayout>;
SalesProPage.title = 'Sales Pro - Ad Management';

export default SalesProPage;
